/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAccountCreateMutation($displayName: String!, $customerId: ID!) {
  CustomerAccountCreate(customerId: $customerId, displayName: $displayName) {
    id,
    message
    status
  }
}
`
